import Vue from '@mindful-web/marko-web/browser/vue';
import VModal from 'vue-js-modal/dist/index.nocss';
import jQuery from '@mindful-web/marko-web/browser/jquery-full';
import RevealAd from '@mindful-web/marko-web-reveal-ad/browser';
import Inquiry from '@mindful-web/marko-web-inquiry/browser';
import DefaultTheme from '@mindful-web/marko-web-theme-default/browser';
import GTM from '@mindful-web/marko-web-gtm/browser';
import GAM from '@mindful-web/marko-web-gam/browser';
import GCSE from '@mindful-web/marko-web-gcse/browser';
import SocialSharing from '@mindful-web/marko-web-social-sharing/browser';
import PhotoSwipe from '@mindful-web/marko-web-photoswipe/browser';

Vue.use(VModal);

const CompanyProfileWebsiteLink = () => import(/* webpackChunkName: "company-profile-website-link" */ './website-link.vue');
const CompanyProfileSocialLink = () => import(/* webpackChunkName: "company-profile-social-link" */ './social-link.vue');
const JumpModal = () => import(/* webpackChunkName: "jump-modal" */ './jump-modal.vue');

window.jQuery = jQuery;
window.$ = jQuery;

export default (Browser) => {
  DefaultTheme(Browser);
  GTM(Browser);
  GAM(Browser);
  GCSE(Browser);
  RevealAd(Browser);
  SocialSharing(Browser);
  PhotoSwipe(Browser);
  Inquiry(Browser);

  Browser.register('CompanyProfileWebsiteLink', CompanyProfileWebsiteLink);
  Browser.register('CompanyProfileSocialLink', CompanyProfileSocialLink);
  Browser.register('JumpModal', JumpModal);
};
